import eyeImg from "assets/eye-slash.svg";
import eyeHideImg from "assets/eye.svg";
import { useState } from "react";
import "./Input.scss";

type InputProps = {
  label: string;
  type: any;
  placeholder?: string;
  toggleVisibility?: () => void;
  secure?: boolean;
  required?: boolean;
  onChange?: any;
  onBlur?: any;
  style?: any;
  mandatory?: string;
  disabled?: boolean;
  defaultValue?: string;
  name?: string;
  value?: string | number;
  className?: string;
};

const Input = (props: InputProps) => {
  const [visible, setVisible] = useState(false);

  const {
    label,
    type,
    secure,
    required,
    value,
    onChange,
    mandatory,
    className,
  } = props;

  const toggleVisibility = () => {
    setVisible(!visible);
  };

  const setInputType = () => {
    let inputType = type;
    if (secure) {
      if (visible) {
        inputType = "text";
      }
    }

    return inputType;
  };

  return (
    <div className="form-group">
      <label className="capitalize">
        {label}
        {mandatory && <span className="danger mandatory">{mandatory}</span>}
      </label>
      <div className="input-wrapper">
        {secure && (
          <img
            onClick={toggleVisibility}
            className="vector-img"
            src={visible ? eyeHideImg : eyeImg}
            alt="vector-img"
          />
        )}
        <input
          className={className}
          {...props}
          type={setInputType()}
          required={required}
          value={value}
          onChange={onChange}
          autoComplete="off"
        />
      </div>
    </div>
  );
};

export default Input;
